import { useSnackbar } from "notistack"
import { useEffect } from "react"
import { useFreeServiseTimesQuery } from "../../../../api/timeTerms/hooks"
import { ActivationObject } from "../../../providers/ActivationObjectProvider/types"
import { Step2FormOptionsProps, Step2FormProps } from "../types"

const useStep2FormOptions = (form: Step2FormProps["form"], activationObject?: ActivationObject): Step2FormOptionsProps => {
    const handoverDate = form.watch("handoverDate")
    const backHandoverDate = form.watch("backHandoverDate")
    const selectedService = form.watch("selectService")

    const getHandoverDate = selectedService === "BaseProtection" && activationObject?.isAvailableKey ? backHandoverDate : handoverDate

    const {
        data: handoverTimes,
        isLoading: isHandoverTimesLoading,
        error: handoverTimesError,
    } = useFreeServiseTimesQuery(activationObject?.arrivalVehicle, activationObject?.synonym, getHandoverDate)

    // handle options loading error
    const { enqueueSnackbar } = useSnackbar()
    useEffect(() => {
        if (handoverTimesError) enqueueSnackbar(handoverTimesError.detail, { variant: "error" })
    }, [enqueueSnackbar, handoverTimesError])

    return {
        handoverTimes: handoverTimes?.days
            .filter((d) => d.isAvailable)
            .map((d) => {
                return {
                    value: d.intervalFrom,
                    label: `${d.intervalFrom}:00 - ${d.intervalTo}:00`,
                }
            }),
        isHandoverTimesLoading,
    }
}

export default useStep2FormOptions
